import { TruckingCompany } from 'types';
import { FilterOperator, FilterState, LogicalOperator, filtersToRsqlString, joinRsql } from 'utils';
import fetchWithRetry from './fetch-retry';

export const getTruckingCompanies = async (): Promise<TruckingCompany[]> =>
  await fetchWithRetry<TruckingCompany[]>('/api/trucking-companies', { method: 'GET' }, []);

export const getTruckingCompanyById = async (id: number): Promise<TruckingCompany | null> =>
  await fetchWithRetry<TruckingCompany | null>(`/api/trucking-companies/${id}`, { method: 'GET' }, null);

export const searchTruckingCompanies = async (
  input: string,
  filterByUserAssociations = true
): Promise<TruckingCompany[]> => {
  const url = new URL('/api/trucking-companies/search', window.location.origin);

  /* split on special characters / whitespace */
  const terms = input.split(/[^a-zA-Z0-9]/);

  const nameFilter: FilterState = {
    logicalOperator: LogicalOperator.AND,
    filters: terms.map(value => ({ field: 'name', value, filterOperator: FilterOperator.CONTAINS }))
  };

  const scacFilter: FilterState = {
    logicalOperator: LogicalOperator.AND,
    filters: terms.map(value => ({ field: 'scacCode', value, filterOperator: FilterOperator.CONTAINS }))
  };

  url.searchParams.append('filterByUserAssociations', filterByUserAssociations.toString());
  const filterString = joinRsql(LogicalOperator.OR, filtersToRsqlString(nameFilter), filtersToRsqlString(scacFilter));
  url.searchParams.append('filterString', filterString);

  return await fetchWithRetry<TruckingCompany[]>(url, { method: 'GET' }, []);
};

export const validateScac = async (scac: string): Promise<boolean> =>
  await fetchWithRetry<boolean>(`/api/trucking-companies/validation/scac/${scac}`, { method: 'GET' }, false);
